import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import ArrowLeft from '../../Assets/Arrow left.svg';
import showhide from "../../Assets/ShowHide.svg";
import DotsVertical from '../../Assets/VerticalDot.svg';
import ProductImages from './Components/ProductImages';
import ProductDetails from './Components/ProductDetails';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInventoryProduct } from '../../Features/inventoryManagementSlice';
import Loading from '../../Components/Loading/Loading';
import { accessProductVisibility, cachedDataPublish, updateProduct } from '../../lib/utils/apiCalls';
import { showToast } from '../../Components/Toaster/Toaster';
import ProductDetailsKebab from './Components/ProductDetailsKebab';
import { useOutsideClickForTwoRef } from '../../Hooks/useOutsideClickForTwoRef';
import Modal from './Components/Modals/Modal';
import Error from '../../Components/Error/Error';
import LoadingTransparent from '../../Components/Loading/LoadingTransparent';

function InventoryProductDetails() {
    const getStatusColor = (prodStatus) => {
        if(!prodStatus) {
            prodStatus = activeProduct?.product?.status;
        }
        switch (prodStatus) {
            case 'Active':
                return 'text-[#065F46] bg-[#D1FAE5]';
            case 'Draft':
                return 'text-[#92400E] bg-[#FEF3C7]';
            case 'Out Of Stock':
                return 'text-[#991B1B] bg-[#FEE2E2]';
            case 'InActive':
                return 'text-[#666666] bg-[#EAEAEA]';
            case 'Inactive':
                return 'text-[#666666] bg-[#EAEAEA]';
            default:
                return '';
        }
    };

    const params = useParams();
    const location = useLocation();
    const dispatch = useDispatch();

    const[statusLoading, setStatusLoading] = useState(false);

    const kebabRef = useRef(null);
    const kebabButtonRef = useRef(null);

    useOutsideClickForTwoRef(kebabRef, kebabButtonRef, () => {
        setKebabVisible(false);
    });

    const [kebabVisible, setKebabVisible] = useState(false);

    const handleDotsClick = () => {
        setKebabVisible(!kebabVisible);
    }

    const [productVisible, setProductVisible] = useState(true);
    const [productStatus, setProductStatus] = useState('');

    const { activeProduct, loading } = useSelector((state) => state.inventoryManagement.activeProduct);

    useEffect(() => {
        const getProductVisibilityStatus = async () => {
            try {
                const response = await accessProductVisibility(params.productId);
                setProductVisible(response.isVisible);
            }
            catch(err) {
                console.log(err);
            }
        }

        if(params.productId) {
            dispatch(fetchInventoryProduct(params.productId));
            getProductVisibilityStatus();
        }
        // eslint-disable-next-line
    }, [params.productId]);

    const handleToggleClick = async () => {
        setStatusLoading(true);
        const productId = location.pathname.split('/').reverse()[0];

        let visibilityValue;

        if(productVisible) {
            visibilityValue = false;
        }
        else {
            visibilityValue = true;
        }

        try {
            let callData = {
                isVisible: visibilityValue
            }

            if(!visibilityValue) {
                callData.status = 'Inactive';
            }
            else {
                if(activeProduct?.product?.status === 'Out of Stock') {
                    callData.status = 'Out of Stock';
                }
                else {
                    callData.status = 'Active';
                }
            }

            const response = await updateProduct(callData, productId);

            if(response?.status === 200) {
                await cachedDataPublish([`/v1/product/${productId}`]);
                setStatusLoading(false);
                const response = await accessProductVisibility(productId);
                setProductVisible(response.isVisible);
                setProductStatus(response.isActive);
            }
            else {
                setStatusLoading(false);
                showToast('Unexpected error', 'error');
            }
        }
        catch(err) {
            setStatusLoading(false);
            showToast('Unexpected error', 'error');
        }
    }

    if(loading === 'loading') {
        return <Loading />
    }

    if(loading === 'failed') {
        return <Error />
    }

    return (
        <div className="w-full overflow-y-scroll pb-16">
            <div className="w-[calc(100%-19px-20px)] select-none flex items-start justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-[calc(100%-24px-240px)] flex items-start">
                    <Link to='..' className="p-[10px] flex items-center justify-center">
                        <img className='size-6 text-[#666666]' src={ArrowLeft} alt="" />
                    </Link>

                    <h1 className="w-[calc(100%-24px)] p-[6px] text-[#121212] font-bold leading-8 text-[24px] line-clamp-2">{activeProduct?.product?.productName}</h1>
                </div>

                <div className="flex items-center gap-3 mt-[10px]">
                    <div className={`text-center font-medium text-[14px] leading-5 rounded-xl px-3 py-[2px] ${getStatusColor(productStatus)}`}>
                        <h2>{productStatus || activeProduct?.product?.status}</h2>
                    </div>

                    <button onClick={handleToggleClick} className={`outline-none flex items-center w-11 h-6 p-[2px] rounded-xl ${productVisible ? 'bg-[#4F46E5]' : 'bg-[#E5E7EB]'}`}>
                        <img className={`${productVisible ? 'ml-auto mr-[-2px]' : 'ml-[-2px]'} rounded-full`} src={showhide} alt="" />
                    </button>

                    {/* <div onClick={handleDotsClick} ref={kebabButtonRef} className="relative size-11 outline-none flex items-center justify-center cursor-pointer">
                        <img src={DotsVertical} alt="" />

                        <ProductDetailsKebab 
                            kebabOpen={kebabVisible} 
                            boxRef={kebabRef} 
                        />
                    </div> */}
                </div>
            </div>

            <div className="flex gap-3 mx-5">
                <ProductImages />

                <ProductDetails />
            </div>

            <Modal />

            {statusLoading && <LoadingTransparent message="Updating product status..." />}
        </div>
    );
}

export default InventoryProductDetails;
